import type * as Types from '../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SmartRoutingDataQueryVariables = Types.Exact<{
  input: Types.StationeryDraftsByEventInput;
  filters?: Types.InputMaybe<Types.StationeryPrintOrdersFiltersInput>;
}>;

export type SmartRoutingDataQuery = {
  __typename?: 'Query';
  stationeryDrafts: Array<{
    __typename?: 'StationeryDraft';
    id: string;
    stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; category: Types.StationeryTemplateCategoryEnum };
  }>;
  stationeryPrintOrders: {
    __typename?: 'StationeryPrintOrdersView';
    orders: Array<{
      __typename?: 'StationeryPrintOrder';
      id: string;
      cardDraft?: {
        __typename?: 'StationeryDraft';
        id: string;
        stationeryTemplate: { __typename?: 'StationeryTemplate'; id: string; category: Types.StationeryTemplateCategoryEnum };
      } | null;
    }>;
  };
};

export const SmartRoutingDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SmartRoutingData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryDraftsByEventInput' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StationeryPrintOrdersFiltersInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'stationeryDrafts' },
            name: { kind: 'Name', value: 'stationeryDraftsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stationeryTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryPrintOrders' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'filters' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cardDraft' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stationeryTemplate' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSmartRoutingDataQuery__
 *
 * To run a query within a React component, call `useSmartRoutingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartRoutingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartRoutingDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSmartRoutingDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SmartRoutingDataQuery, SmartRoutingDataQueryVariables>) {
  return ApolloReactHooks.useQuery<SmartRoutingDataQuery, SmartRoutingDataQueryVariables>(SmartRoutingDataDocument, baseOptions);
}
export function useSmartRoutingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SmartRoutingDataQuery, SmartRoutingDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<SmartRoutingDataQuery, SmartRoutingDataQueryVariables>(SmartRoutingDataDocument, baseOptions);
}
export type SmartRoutingDataQueryHookResult = ReturnType<typeof useSmartRoutingDataQuery>;
export type SmartRoutingDataLazyQueryHookResult = ReturnType<typeof useSmartRoutingDataLazyQuery>;
export type SmartRoutingDataQueryResult = Apollo.QueryResult<SmartRoutingDataQuery, SmartRoutingDataQueryVariables>;
